<template>
    <div class="navigation">
        <Widget position="MainMenu" />
<!--        <ul>-->
<!--            <li>-->
<!--                <router-link to="/">-->
<!--                    <img src="@/assets/img/menu/home.png" alt="Главная">Главная-->
<!--                </router-link>-->
<!--            </li>-->
<!--            <li>-->
<!--                <a href="#">-->
<!--                    <img src="@/assets/img/menu/air.png" alt="Воздух">Воздух-->
<!--                </a>-->
<!--            </li>-->
<!--            <li>-->
<!--                <a href="#">-->
<!--                    <img src="@/assets/img/menu/biodiversity.png" alt="Биоразнообразие">Биоразнообразие-->
<!--                </a>-->
<!--            </li>-->
<!--            <li>-->
<!--                <a href="#">-->
<!--                    <img src="@/assets/img/menu/power-engineering.png" alt="Энергетика">Энергетика-->
<!--                </a>-->
<!--            </li>-->
<!--            <li>-->
<!--                <a href="#">-->
<!--                    <img src="@/assets/img/menu/security.png" alt="Охрана">Охрана ОС-->
<!--                </a>-->
<!--            </li>-->
<!--            <li>-->
<!--                <a href="#">-->
<!--                    <img src="@/assets/img/menu/climate.png" alt="Изменение климата">Изменение климата-->
<!--                </a>-->
<!--            </li>-->
<!--            <li>-->
<!--                <a href="#">-->
<!--                    <img src="@/assets/img/menu/land.png" alt="Земельные участки">Земельные участки-->
<!--                </a>-->
<!--            </li>-->
<!--            <li>-->
<!--                <a href="#">-->
<!--                    <img src="@/assets/img/menu/transport.png" alt="Транспорт">Транспорт-->
<!--                </a>-->
<!--            </li>-->
<!--            <li>-->
<!--                <a href="#">-->
<!--                    <img src="@/assets/img/menu/contacts.png" alt="Контакты">Контакты-->
<!--                </a>-->
<!--            </li>-->
<!--            <li>-->
<!--                <router-link to="/water-resource">-->
<!--                    <img src="@/assets/img/menu/water.png" alt="Водные ресурсы">Водные ресурсы-->
<!--                </router-link>-->
<!--            </li>-->
<!--            <li>-->
<!--                <a href="#">-->
<!--                    <img src="@/assets/img/menu/farming.png" alt="Селськое хозяйство">Сельское хозяйство-->
<!--                </a>-->
<!--            </li>-->
<!--            <li>-->
<!--                <a href="#">-->
<!--                    <img src="@/assets/img/menu/waste.png" alt="Отходы">Отходы-->
<!--                </a>-->
<!--            </li>-->
<!--        </ul>-->
    </div>
</template>

<script>
    import Widget from "@/components/app/Widget";

    export default {
        name: "Navigation",
        components: {
            Widget
        }
    }
</script>

<style scoped>

</style>
